import { render, staticRenderFns } from "./EllipseElement.vue?vue&type=template&id=4b965ce3&scoped=true&"
import script from "./EllipseElement.vue?vue&type=script&lang=js&"
export * from "./EllipseElement.vue?vue&type=script&lang=js&"
import style0 from "./EllipseElement.vue?vue&type=style&index=0&id=4b965ce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b965ce3",
  null
  
)

export default component.exports